<template>
  <div id="join">
    <div class="banner">
      <img src="../assets/image/bg_5.png" alt="加入我们" width="100%" />
      <BoxLine>加入我们</BoxLine>
    </div>
    <div class="ourInfo">
      <div class="title">
        <img src="../assets/image/bg_6.png" alt="" />
        <p>我们寻求的人都热爱自己的专业，<br />力求创新，致力于追求卓越</p>
      </div>
      <p class="info-text">
        安徽中设国际会展集团有限公司是一家集会展策划营销、展会运营管理、展览陈列设计、展台制作搭建、装饰设计施工、广告传媒创意、文创产品开发、项目投资发展的专业性同心多元化会展公司。公司旗下拥有中设创意展览、中设国礼文化、金晖广告传媒、中亚装饰工程等全资子公司。
      </p>
    </div>
    <h4 class="next">下一个中设精英就是你</h4>
    <Job />
    <Why />
    <img class="brand" src="../assets/image/brand.png" alt="" />
  </div>
</template>
<script>
import BoxLine from "@/components/box-line.vue";
import Job from "@/components/join/job.vue";
import Why from "@/components/join/why.vue";
export default {
  name: "join-page",
  components: {
    BoxLine,
    Why,
    Job,
  },
};
</script>

<style lang="scss" scoped>
#join {
  .banner {
    position: relative;
    img {
      height: 140px;
    }
  }
  .ourInfo {
    .title {
      color: #314659;
      font-size: 20px;
      font-weight: 600;
      position: relative;
      p {
        position: absolute;
        bottom: 20px;
        left: 16px;
      }
    }
    .info-text {
      padding: 16px;
      line-height: 22px;
    }
  }
  .next {
    color: #333;
    padding: 0 16px;
    font-weight: 600;
  }
  .brand {
    margin: 20px 16px;
  }
}
</style>